module.exports = __webpack_public_path__ + "static/media/vivi-andando-1.77b00637.svg";